import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSpeed = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(2.2512 4.4232)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M9.75 0C15.1348 0 19.5 4.36522 19.5 9.75C19.5 11.7422 18.9019 13.597 17.875 15.1416L16.625 14.3115C17.4935 13.0053 18 11.4378 18 9.75C18 5.19365 14.3063 1.5 9.75 1.5C5.19365 1.5 1.5 5.19365 1.5 9.75C1.5 11.4378 2.0065 13.0053 2.875 14.3115L1.625 15.1416C0.59814 13.597 0 11.7422 0 9.75C0 4.36522 4.36522 0 9.75 0ZM14.2803 6.28027L10.2803 10.2803L9.21973 9.21973L13.2197 5.21973L14.2803 6.28027Z",
			fill: "currentColor"
		})
	})
});
export default SvgSpeed;
